import script from "./legend.vue?vue&type=script&setup=true&lang=ts"
export * from "./legend.vue?vue&type=script&setup=true&lang=ts"

import "./legend.vue?vue&type=style&index=0&id=c82f8776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82f8776"]])

export default __exports__